// ** React Imports
import { useCallback } from "react";

// ** Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Utils & Helpers
import { VIP_STATUS } from "helpers/constants";

// #####################################################

const useCanComment = (mediaItem = {}) => {
	const user = useSelector((store) => store.globalUser);
	const { duration } = useSelector((store) => store.globalUser.suspension);

	const { t } = useTranslation(["common", "suspensions"]);

	const { status_vip, avatar } = user;

	// ** W zależności od miejsca pobierania danych pliku opcja 'canComment'
	// ** i 'filterComment' występuja również jako: 'can_comment' oraz 'filter_comment'
	const { can_comment, canComment, filter_comment, filterComment, limit } =
		mediaItem;

	// ** Sprawamy czy użytkownik posiada domyślny avatar
	const isDefaultAvatar = useCallback(() => {
		return avatar.includes("/static/");
	}, [avatar]);

	// ** Użytkownik posiada bana
	if (duration > 0) {
		return {
			commentsDisabled: true,
			linkOnButtonToPayments: false,
			cantCommentMessage: t("suspensions:bannedAccount"),
		};
	}

	// ** Użytkownik może komentować dany post / zdjęcie / wideo
	if ((can_comment === true || canComment === true) && !limit) {
		return {
			commentsDisabled: false,
			linkOnButtonToPayments: false,
			cantCommentMessage: "",
		};
	}
	// ** Użytkownik nie może komentować
	else {
		// ** Posiada domyślny avatar i status < VIP
		if (isDefaultAvatar() && status_vip <= VIP_STATUS.VERIFIED) {
			return {
				commentsDisabled: false,
				linkOnButtonToPayments: true,
				cantCommentMessage: t("common:cantCommentLimitWhenNoVipShort"),
			};
		}
		// ** Posiada status < VIP i napisał już 1 post w cigu 24h
		if (status_vip <= VIP_STATUS.VERIFIED && limit) {
			return {
				commentsDisabled: false,
				linkOnButtonToPayments: true,
				cantCommentMessage: t("common:cantCommentLimitWhenNoVipShort"),
			};
		}
		// ** Posiada status VIP i napisał już 30 postów w cigu 24h
		if (status_vip === VIP_STATUS.VIP && limit) {
			return {
				commentsDisabled: false,
				linkOnButtonToPayments: true,
				cantCommentMessage: t("common:cantCommentLimitWhenVipShort"),
			};
		}

		if (filter_comment || filterComment) {
			// ** Autor zdjęcia / filmu zablokował możliwość komentowania
			return {
				commentsDisabled: true,
				linkOnButtonToPayments: false,
				cantCommentMessage: t(
					"common:cantCommentCommentsBlockedByUser"
				),
			};
		}
	}

	// ** Domyślny warunek
	return {
		commentsDisabled: false,
		linkOnButtonToPayments: false,
		cantCommentMessage: "",
	};
};

export default useCanComment;
